var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cloudgroupcache-list',{attrs:{"id":"CloudgroupcacheListForCloudgroupSidepage","get-params":_vm.getParams,"is-owner":_vm.isOwner}})
}
var staticRenderFns = []

export { render, staticRenderFns }